import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
// import * as qs from "query-string";

import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import appg from "../appg";
import Header from "./Header";
import ResetPass from "./ResetPass";
import Index from "./Index";
import ChangeEmail from "./ChangeEmail";

class App extends React.Component {
  state = {};

  renderContent = () => {
    return (
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/resetpass/:token" element={<ResetPass />} />;
        <Route path="/changeemail/:token" element={<ChangeEmail />} />;
      </Routes>
    );
  };

  render() {
    return (
      <div className="ui container">
        <Toast ref={(el) => (appg.toast = el)} />
        <HashRouter>
          <div>
            <Header onLogout={this.onLogout} />
            {this.renderContent()}
          </div>
        </HashRouter>
      </div>
    );
  }
}

export default App;
